
import React, { memo, useEffect, useMemo, useState } from 'react'
import { useHistory } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { addCoupon, auth, database, db, sendMessage, signInWithGoogle, upladNewUser, version } from '../../firebase';
import line from '../../image/line.png'
import Navbar from '../sidebar/sidebar';
import { addDoc, collection, getDocs, query, where } from 'firebase/firestore';
import Container from '../aboutUs/components/container';
import MenuSmall from '../menu/menuSmall';
import EBox from './components/eventsHandler';
import pic24_7 from '../../image/icon247.png'
import picone from '../../image/iconone.png'
import ButtomPage from '../buttomPage';
import { onValue, ref } from 'firebase/database';
import { Button } from '@material-ui/core';
import { BiLeftArrow } from 'react-icons/bi';
import { ArrowLeft } from 'phosphor-react';
import ContributionBox from './components/contributionBox';
import Wheelbutton from '../weelOfLuck/wheelbutton';

function HomePage() {
    const history = useHistory();
    const [user, loading] = useAuthState(auth);
    const [account, setAccount] = useState([]);
    const [points, setPoints] = useState([]);
    const [status, setStatus] = useState("");
    const [flag, setFlag] = useState(false);


    let nicepic = "";
    var randomIndex = (Math.random())
    if (randomIndex < 0.3)
        nicepic = "nicepic1"
    else if (randomIndex > 0.6)
        nicepic = "nicepic2"
    else
        nicepic = "nicepic3"
    useEffect(() => {
        localStorage.clear()
    }, []);

    useEffect(() => {
        if (loading) return;
        if (!user) return;
        const query = ref(database, "Account/" + user.uid);
        return onValue(query, (snapshot) => {
            if (snapshot.exists()) {
                const data = snapshot.val();
                console.log(data)
                console.log(data.uid)
                if (!data.uid)
                    setFlag(true)
                else {
                    setAccount(data);
                    setPoints(data.points ? data.points : 0);
                }
            }
            else setFlag(true)
        })
    }, [user, loading]);

    useEffect(() => {
        async function fetchUserName() {
            try {
                const q = query(collection(db, "Users"), where("uid", "==", user?.uid));
                const doc = await getDocs(q);
                if (doc.docs.length > 0) {
                    const data = doc.docs[0].data();
                    if (flag) {
                        setAccount(data);
                        setPoints(data.points ? data.points : 0);
                    }
                }
                else {
                    alert("מכניס חדש למערכת")
                    // addCoupon("צ'ייסר", 0, 1, user.uid, "מתנה לנרשמים חדשים", "", "off")
                    await addDoc(collection(db, "Users"), {
                        uid: user.uid,
                        name: user.displayName,
                        authProvider: "homePage",
                        email: user.email,
                        birthDate: "",
                        adress: "",
                        phone: "",
                        account: "newAccount",
                        tax: "false",
                        payBox: "false",
                        discount: 0,
                    }).then(addCoupon("צ'ייסר", 0, 1, user.uid, "מתנה לנרשמים חדשים", "", "off")).then
                        (alert("מחכה לך קופון באיזור הפריטים שלי"));
                }
            } catch (err) {
                console.log(err);
            }
        };
        if (loading) return;
        if (user && flag) {
            fetchUserName();
        }
    }, [flag]);


    useEffect(() => {
        if (flag === true) {
            upladNewUser(account);
        }
    }, [account])

    const onSubmitWelcome = (event) => {
        console.log("onSubmitWelcome", event);
        if (event === "givon") {
            history.push("login")
            console.log(event);
            window.scrollTo(0, 0)
        }
        if (event === "visit") {
            history.push("register")
            console.log(event);
            window.scrollTo(0, 0)
        }
        if (event === "google") {
            if (!user) {

                console.log(event);
                window.scrollTo(0, 0)
                signInWithGoogle()
            }
        }


    };



    const toMenu = () => {
        history.push("/menu")
        window.scrollTo(0, 0)
    }

    
    useEffect(() => {
        const query = ref(database, "bar");
        return onValue(query, (snapshot) => {
            const data = snapshot.val();
            setStatus(data.status)
        }, {
            onlyOnce: true
        });
    }, []);

    return (
        <>
            
                <div id="page-wrap" className='background_white top_padding_home'>
                    {/*
                    {/* <img src={wallpaper} className="welcome_image" alt="logo" /> */}

                    {/* <div className="div_master"> */}
                    {/* <img src={header} className="width70" alt="logo" /> */}
                    {/* </div> */}
                   
                   
                   {/* disabled welcome jumping screen */}
                    {/* {!user &&
                        <Container triggerText={"Welcome"} onSubmit={onSubmitWelcome} kind={"welcome"}></Container>

                    } */}



                    {/* 
                    <div className={"pic_home_text " + nicepic} >
                        <div className='text_white black_shadow text3 w600 home_image bottom20'>פאב גבעון</div>
                        <div className='text_white black_shadow text2 w400 home_image bottom10'>כי בירה שותים יחד</div>
                        <br /><br />
                        <img src={menu} height={70} alt="logo" onClick={toMenu} className="home_image bottom0" />
                    </div> */}

                    {/* <Gallery /> */}
                    <div className={"pic_home nicepic1"} >
                        {/* <div className="pic_home_text_up">
                            <div className='text_white black_shadow text2 w600  '>הפאב פתוח <BiHappyBeaming /></div>
                        </div> */}
                        <div className="pic_home_text_botttom">
                            <div className='text_white black_shadow text2_5 w600 '>פאב גבעון</div>
                            <div className='text_white black_shadow text_sub text1_5 w400  '>כי בירה שותים יחד
                                <br />
                                {points > 0 ? <>  גלגל המזל: <Wheelbutton /> <br /></> : <></>}
                                <br />
                            </div>
                            <span onClick={toMenu} className=" text_title_img text2  " >
                                <span className=" text1_5 w700 p3 margin-25" ><ArrowLeft /></span>
                                <span className=" text2 w700 margin20" >תפריט</span>
                            </span>
                            <br /><br />
                            {/* <img src={menu} height={60} alt="logo" onClick={toMenu} /> */}
                        </div>
                    </div>

                    {/* {status === "סגור" &&
                        <div className={"pic_home nicepic1"} >

                            <div className="pic_home_text_up">
                                <div className='text_white black_shadow text2 w400  '>הפאב סגור כעת <FaSadTear /></div>
                            </div>
                            <div className="pic_home_text_botttom">

                                <div className='text_white black_shadow text3 w600 '></div>
                                <div className='text_white black_shadow text3 w600 '>פאב גבעון</div>
                                <div className='text_white black_shadow text2 w400  '>כי בירה שותים יחד</div>
                                <br />
                            </div>
                        </div>} */}

                    {/* <div id="product-title"></div> */}
                    {/* <img src={line} className="line_png" alt="logo" /> */}
                    <center>
                        {/* <ContributionBox /> */}
                    </center>
                    <center>
                        <EBox />
                    </center>
                    <br />
                    <div className='text_center black_shadow text3 w100 p3'>אנחנו מציעים:</div>
                    <br />
                    <MenuSmall />
                    <br />
                    <img src={line} className="line_png" alt="logo" />
                    <br /> <br />
                    <div className='split_div padding10'>
                        <div className='left_div'>
                            <img className="logo_home_bottom" src={picone} />
                            <div className='text_brown text1_5 w600 p3'>מספר 1</div>
                            <div className='text_brown text_sub text1_2 w400 p1 '>הפאב הכי טוב בגבעון</div>
                        </div>
                        <div className='right_div'>
                            <img className="logo_home_bottom" src={pic24_7} />
                            <div className='text_brown text1_5 w600 p3'>24/7 תמיכה</div>
                            <div className='text_brown text_sub text1_2 w400 p1'>אנחנו תמיד כאן בשביל בשבילכם</div>
                        </div>
                    </div>
                    <br /><br />
                    <ButtomPage />
                </div>
           
        </>
    )
}

export default memo(HomePage)
